(() => {
  const motion = matchMedia('(prefers-reduced-motion: reduce)');
  if (!('IntersectionObserver' in window)) return;
  // After the startup fallback has shown artwork, keep it visible instead of replaying.
  if (!motion.matches && !document.documentElement.classList.contains('dd-stamps-pending')) return;
  const selector = '#MainContent > .shopify-section:first-child .dd-split-hero .dd-svg-overlay';
  const seen = new WeakSet();
  const observer = new IntersectionObserver((entries) => {
    for (const entry of entries) {
      if (!entry.isIntersecting || motion.matches) continue;
      entry.target.setAttribute('data-dd-stamp-entered', '');
      seen.add(entry.target);
      observer.unobserve(entry.target);
    }
  }, { threshold: .35 });
  const observe = (root) => {
    if (motion.matches) return;
    const sections = new Set();
    let count = 0;
    for (const stamp of root.querySelectorAll(selector)) {
      if (!stamp.getClientRects().length) continue;
      const section = stamp.closest('.shopify-section');
      if (seen.has(stamp) || sections.has(section) || count >= 3) continue;
      sections.add(section);
      count += 1;
      stamp.setAttribute('data-dd-stamp-ready', '');
      observer.observe(stamp);
    }
  };
  observe(document);
  document.documentElement.classList.remove('dd-stamps-pending');
  document.addEventListener('shopify:section:load', (event) => observe(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll(selector).forEach((stamp) => observer.unobserve(stamp));
  });
  motion.addEventListener('change', () => {
    observer.disconnect();
    if (!motion.matches) observe(document);
  });
})();
